




















import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { IMapLabel, IMapLabelWithAttributes } from '@frontend/types/modules/IMaps';
import { getCoordinatesInPercent } from '@frontend/utils/PositioningUtil';

@Component({
	componentId: 'C048',
	hydration: true,
	components: {}
})
export default class Map extends Vue {
	@Prop(String)
	protected readonly map!: string;

	@Prop(Array)
	protected readonly labels!: IMapLabel[];

	protected labelsWithAttributes: IMapLabelWithAttributes[] = [];

	protected mounted(): void {
		this.$nextTick(() => {
			this.createLabelsWithAttributes();
		});
	}

	protected createLabelsWithAttributes(): void {
		const svgWrapper = this.$refs.svgWrapper as HTMLElement;

		if (!svgWrapper) return;

		const placeHolderQueryString = '[id^=pin_]';
		const labelPlaceHolders: Element[] = Array.from(svgWrapper.querySelectorAll(placeHolderQueryString)).reverse();

		this.labelsWithAttributes = labelPlaceHolders.reduce((acc, labelPlaceHolder) => {
			const elementId = labelPlaceHolder.id;
			const pinId = this.getIdFromLabelPlaceHolder(elementId);
			const originalLabelData = this.labels.find(labelItem => labelItem.svgId === pinId);
			const position = getCoordinatesInPercent(labelPlaceHolder, svgWrapper);
			const params = this.getParamsForLabelPlaceholder(elementId);

			if (!originalLabelData) return acc;

			const data = { ...originalLabelData, ...position, ...params };

			acc.push(data);
			return acc;
		}, [] as IMapLabelWithAttributes[]);
	}

	protected getIdFromLabelPlaceHolder(elementId: string): string {
		return elementId.split('_')[1];
	}

	protected getParamsForLabelPlaceholder(elementId: string): Record<string, string> {
		const all = elementId.split('_');
		const paramsArray = all.splice(2, all.length).map((item): string[] => item.split(':'));

		return paramsArray.reduce((acc: Record<string, string>, item) => {
			acc[item[0]] = item[1];
			return acc;
		}, {});
	}
}
